"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const es_1 = __importDefault(require("date-fns/locale/es")); //
const dateEsAR = {
    name: 'es-AR',
    locale: es_1.default
};
exports.default = dateEsAR;
